import { render, staticRenderFns } from "./FormInstallmentPlan.vue?vue&type=template&id=0452b3c8&scoped=true&"
import script from "./FormInstallmentPlan.vue?vue&type=script&lang=js&"
export * from "./FormInstallmentPlan.vue?vue&type=script&lang=js&"
import style0 from "./FormInstallmentPlan.vue?vue&type=style&index=0&id=0452b3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452b3c8",
  null
  
)

export default component.exports